import { useDbtCloudProject } from '@/context/DbtCloudProjectProvider';
import { useProjectScope } from './params';

interface EnvironmentScope {
  environmentType: string;
  userId: number | null | 'loading';
}

export const useEnvironmentScope = (): EnvironmentScope => {
  const { environmentType } = useProjectScope();
  const { userId } = useDbtCloudProject();
  return {
    environmentType,
    userId: environmentType === 'development' ? userId : null,
  };
};
